import { __assign } from "tslib";
import { escapeHtmlEntities, getDefaultWhiteList, filterXSS } from 'xss';
export var sanitizeHtml = function (html) {
    var options = {
        whiteList: __assign(__assign({}, getDefaultWhiteList()), { span: ['style'], a: ['target', 'href', 'title', 'data-hook'], kbd: [] }),
    };
    return filterXSS(html, options);
};
export var escapeHtml = function (value) {
    return escapeHtmlEntities(value);
};
//# sourceMappingURL=xss.js.map